export const Boxes = {
  FIRST: 0,
  SECOND: 1,
  NIEUWSBRIEF: 2,
  SOCIALS: 3,
};
